import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import './registrosagenda.css';

export default class RegistrosAgenda extends Component {
  state = {
    registros: [],
  };
  async componentDidMount() {
    const res = await axios.get("http://localhost:5000/api/Agenda/");
    this.setState({ registros: res.data });
  }

  render() {
    return (
      <>
        <div className="container registrosagenda-container">
        <div className='row'>
            <div className='col-12'>
                <div className='registrosagenda_title'>
                    <h1>Registros de la Agenda del Secretario</h1>
                </div>
            </div>
        </div>
          <div className="row">
            <div className="col-md-12">
              <Link to="/NuevoRegistroAgenda">
                <button className="btn btn-secondary float-end">
                  Nuevo Registro
                </button>
              </Link>
            </div>
          </div>
          <div className="row mb-3 mt-3">
            <table className="table">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Lugar</th>
                  <th>Fecha</th>
                  <th>Enlace</th>
                </tr>
              </thead>
              <tbody>
                
                  {this.state.registros.map((registro) => (
                    <>
                      <tr>
                        <td> {registro.title} </td>
                        <td> {registro.place} </td>
                        <td> {registro.start} </td>
                        <td> {registro.description} </td>
                      </tr>
                    </>
                  ))}
                
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
}
